/**
 * @description bank account verification Type
 */
export enum BankAccountVerificationType
{
  SameDayMicroDeposit = 'SameDayMicroDeposit',
  AutomatedMicroDeposit = 'AutomatedMicroDeposit',
  InstantAuth = 'InstantAuth'
}



// WEBPACK FOOTER //
// ./src/model/types/bank-account-verification-type.ts